const generateId = require('../shared/infrastructure/id-generation/generate-id');
const newApi = require('./newApi');
const dayjs = require('dayjs');

const conditionMatchPropsData = require('./conditionMatchPropsData');
const { conditionMatchForApp, propIsNull } = require('./conditionMatchForApp');
const { getTempPropEnumOption, textSort } = require('./getTempPropEnumOption');
// NOTE: 避免导致小程序依赖过大
// const crypto = require('crypto-browserify');
const { Sha256 } = require('@aws-crypto/sha256-browser');
const { CASCADE_CONNECTOR } = require('../constants');
const { Uint8ArrayToHex } = require('../shared/util');

/**
 * @param {string} val
 * @returns Promise<Uint8Array>
 */
async function sha256(val) {
  const hash = new Sha256();
  hash.update(val);
  return Uint8ArrayToHex(await hash.digest('hex'));
}

const generateAddOpId = () => {
  return generateId();
};

const isBetween = (date, range) => {
  const nodeValue = dayjs(date).valueOf();
  const startDate = range[0] || null;
  const endDate = range[1] || null;
  return (
    (nodeValue >= startDate || startDate === null) && (nodeValue <= endDate || endDate === null)
  );
};

const filterNumber = (value, filter) => {
  if (!Number.isFinite(filter.operator) || !Number.isFinite(filter.number) || isNaN(filter.number))
    return true;
  if (propIsNull(value) || !Number.isFinite(Number(value))) return false;
  const fn = Number(value);
  switch (filter.operator) {
    case 0:
      return fn === filter.number;
    case 1:
      return fn !== filter.number;
    case 2:
      return fn > filter.number;
    case 3:
      return fn >= filter.number;
    case 4:
      return fn < filter.number;
    case 5:
      return fn <= filter.number;
  }
  return false;
};

const getSubString32 = (str, max = 32) => {
  if (!str || typeof str !== 'string') return '';
  let totalLength = 0,
    newStr = '';
  const list = str.split('');
  for (let i = 0; i < list.length; i++) {
    const s = list[i];
    if (s.match(/[\u0000-\u00ff]/g)) {
      //半角
      totalLength += 1;
    } else if (s.match(/[\u4e00-\u9fa5]/g)) {
      //中文
      totalLength += 2;
    } else if (s.match(/[\uff00-\uffff]/g)) {
      //全角
      totalLength += 2;
    }
    if (totalLength > max) break;
    newStr = newStr.concat(list[i]);
  }
  return newStr;
};

const copyBrowserUrl = () => {
  let input = document.createElement('input');
  document.body.appendChild(input);
  input.setAttribute('value', window.location.href);
  input.select();
  const res = document.execCommand('copy');
  if (res) {
    document.body.removeChild(input);
    input = null;
  }
};

function getPropValue(prop) {
  if (typeof prop === 'object' && prop !== null) {
    if (Array.isArray(prop)) return prop;
    if (Array.isArray(prop.props)) {
      return prop.props.map((n) => n.value).flat();
    }
    return prop;
  }
  return prop;
}

/**
 *
 * @param {any} formula
 * @param {any[]} prop
 * @param {{
 *  e: {
 *    _sys_task_status?: {
 *      index?: number;
 *    }
 *  }
 * }} self
 * @returns {boolean}
 */
const calcFormula = (formula, prop, self = { e: {} }) => {
  if (formula.type === 'formula' && formula.formula) return calcFormula(formula.formula, prop);
  const input = [];
  if (!Array.isArray(formula.input)) return null;
  for (let i = 0; i < formula.input.length; i++) {
    switch (typeof formula.input[i]) {
      case 'number':
      case 'string':
        input.push(formula.input[i]);
        break;
      case 'object':
        if (formula.input[i] === null) {
          input.push(undefined);
        } else {
          let p;
          switch (formula.input[i].type) {
            case 'cas_prop':
            case 'cas_prop_n':
              return null;
            case 'prop':
              if (formula.input[i].prop >= 0) {
                p = getPropValue(prop[formula.input[i].prop]);
              } else {
                return null;
              }
              switch (typeof p) {
                case 'number':
                case 'bigint':
                case 'string':
                  input.push(p);
                  break;
                default:
                  if (Array.isArray(p)) {
                    if (p.length > 1) {
                      if (
                        formula.op === 'or' ||
                        formula.op === 'fvv' ||
                        formula.op === 'concat' ||
                        formula.op === 'join' ||
                        formula.op === 'sum' ||
                        formula.op === 'avg' ||
                        formula.op === 'max' ||
                        formula.op === 'include' ||
                        formula.op === 'min' ||
                        formula.op === 'and' ||
                        formula.op === 'xor' ||
                        formula.op === 'not' ||
                        formula.op === 'h_to_i' ||
                        formula.op === 'count' ||
                        formula.op === 'empty' ||
                        formula.op === 'if' ||
                        formula.op === 'slice' ||
                        formula.op === 'pass_array' ||
                        formula.op === 'pass'
                      ) {
                        input.push.apply(input, p);
                      } else {
                        input.push(p[0]);
                      }
                    } else if (p.length === 1) {
                      input.push(p[0]);
                    }
                  }
              }
              break;
            case 'const':
              input.push(formula.input[i].const);
              break;
            case 'now':
              input.push(Date.now());
              break;
            case 'status':
              input.push(
                (typeof self.e === 'string' ? JSON.parse(self.e) : self.e)?._sys_task_status
                  ?.index || 0,
              );
              break;
            case 's_prop':
            case 'create_time':
            case 'node_id':
            case 'node_seq':
              return null;
            case 'formula':
              input.push(calcFormula(formula.input[i].formula, prop, self));
              if (input[i] === null) return null;
              break;
            case 'quota':
              return null;
            case 'immediate':
            case 'creator':
            default:
              return null;
          }
        }
        break;
      default:
        return null;
    }
  }
  let ret, n, l;
  switch (formula.op) {
    case 'add':
      if (input.length < 2) return null;
      if (typeof input[0] === 'string') input[0] = parseFloat(input[0]);
      if (typeof input[1] === 'string') input[1] = parseFloat(input[1]);
      return input[0] + input[1];
    case 'subtract':
      if (input.length < 2) return null;
      if (typeof input[0] === 'string') input[0] = parseFloat(input[0]);
      if (typeof input[1] === 'string') input[1] = parseFloat(input[1]);
      return input[0] - input[1];
    case 'multiply':
      if (input.length < 2) return null;
      if (typeof input[0] === 'string') input[0] = parseFloat(input[0]);
      if (typeof input[1] === 'string') input[1] = parseFloat(input[1]);
      return input[0] * input[1];
    case 'divide':
      if (input.length < 2) return null;
      if (typeof input[0] === 'string') input[0] = parseFloat(input[0]);
      if (typeof input[1] === 'string') input[1] = parseFloat(input[1]);
      if (input[1] === 0) return null;
      n = input[0] / input[1];
      l = 10 ** (String(n).length - String(Math.floor(n)).length - 2);
      return String(n).length > 15 && l > 10000 ? Math.round(n * l) / l : n;
    case 'or':
      ret = input[0] || false;
      for (let i = 1; i < input.length && !ret; i++) {
        ret = input[i];
      }
      return !!ret;
    case 'fvv':
      for (let i = 0; i < input.length; i++) {
        switch (typeof input[i]) {
          case 'boolean':
          case 'number':
            return input[i];
          case 'string':
            if (input[i].length) return input[i];
            break;
          default:
            if (input[i]) return input[i];
        }
      }
      return null;
    case 'concat':
      return input
        .map((n) => {
          switch (typeof n) {
            case 'string':
              return n;
            case 'number':
              return n.toString();
            default:
              return '';
          }
        })
        .join('');
    case 'join':
      return input
        .slice(1)
        .map((n) => {
          switch (typeof n) {
            case 'string':
              return n;
            case 'number':
              return n.toString();
            default:
              return '';
          }
        })
        .join(formula.input[0]);
    case 'add_prefix':
      if (input.length === 1) return `${input[0]}null`;
      return input.slice(1).map((n) => input[0] + n);
    case 'sum':
      ret = 0;
      for (let i = 0; i < input.length; i++) {
        if (typeof input[i] === 'string') {
          ret += parseFloat(input[i]);
        } else {
          ret += input[i];
        }
      }
      return ret;
    case 'avg':
      if (input.length === 0) return null;
      ret = 0;
      for (let i = 0; i < input.length; i++) {
        if (typeof input[i] === 'string') {
          ret += parseFloat(input[i]);
        } else {
          ret += input[i];
        }
      }
      n = ret / input.length;
      l = 10 ** (String(n).length - String(Math.floor(n)).length - 2);
      return String(n).length > 15 && l > 10000 ? Math.round(n * l) / l : n;
    case 'include':
      if (input.length < 2) return null;
      return input.slice(1).includes(input[0]);
    case 'index_of':
      if (input.length < 2) return -1;
      if (typeof input[0] !== 'string') input[0] = String(input[0]);
      if (typeof input[1] !== 'string') input[1] = String(input[1]);
      return input[0].indexOf(input[1]);
    case 'max':
      if (input.length < 1) return null;
      ret = input[0];
      for (let i = 1; i < input.length; i++) {
        if (typeof input[i] === 'string') {
          input[i] = parseFloat(input[i]);
        }
        if (input[i] > ret) ret = input[i];
      }
      return ret;
    case 'min':
      if (input.length === 0) return null;
      ret = input[0];
      for (let i = 1; i < input.length; i++) {
        if (typeof input[i] === 'string') {
          input[i] = parseFloat(input[i]);
        }
        if (input[i] < ret) ret = input[i];
      }
      return ret;
    case 'and':
      ret = input[0] || false;
      for (let i = 1; i < input.length && ret; i++) {
        ret = input[i];
      }
      return !!ret;
    case 'xor':
      return !!(input[0] ^ input[1]);
    case 'not':
      return !input[0];
    case 'h_to_i':
      return parseInt(input[0], 16);
    case 'count':
      return input.filter((n) => n !== null && n !== '').length;
    case 'pass_array':
      return input;
    case 'if':
      return input[0] ? input[1] : input[2];
    case 'slice':
      if (typeof input[1] === 'string') input[1] = parseInt(input[1]);
      if (isNaN(parseInt(input[2]))) {
        return String(input[0]).slice(parseInt(input[1]));
      }
      return String(input[0]).slice(parseInt(input[1]), parseInt(input[2]));
    case 'equal':
      return input[0] === input[1];
    case 'less':
      return input[0] < input[1];
    case 'less_equal':
      return input[0] <= input[1];
    case 'great':
      return input[0] > input[1];
    case 'great_equal':
      return input[0] >= input[1];
    case 'i_to_s':
      ret = input[0].toString();
      if (typeof input[1] === 'string') input[1] = parseInt(input[1]);
      if (ret.length < 20) {
        ret = zero[20 - ret.length] + ret;
      }
      if (typeof input[1] === 'number' && input[1] > 0) {
        ret = ret.slice(ret.length - input[1]);
      }
      return ret;
    case 'date':
      return convertDateTime(input[0], input[1]) || '';
    case 'empty':
      return (
        input[0] === null ||
        input[0] === undefined ||
        (Array.isArray(input[0]) && input[0].length === 0) ||
        (typeof input[0] === 'string' && input[0].length === 0)
      );
    case 'random':
      if (input.length === 0) return Math.random();
      return Math.random() * input[0];
    case 'md5':
      if (input.length === 0) return md5('');
      return md5(String(input[0]));
    case 'unhex':
      return parseInt(input[0], 16);
    case 'precision':
      if (typeof input[0] !== 'number' || typeof input[1] !== 'number') return null;
      return parseFloat(input[0].toPrecision(input[1]));
    case 'fixed':
      if (typeof input[0] !== 'number' || typeof input[1] !== 'number') return null;
      return parseFloat(input[0].toFixed(input[1]));
    case 'pass':
      for (let i = 0; i < input.length; i++) {
        if (input[i] !== null && input[i] !== undefined) {
          return input[i];
        }
      }
      return null;
    case 'nick_name':
      return null;
  }
  return null;
};

const genCascadeNodes = (nodes, keyMap, type = 'key') => {
  nodes.forEach((cascade) => {
    keyMap[cascade[type]] = cascade;
    if (Array.isArray(cascade.children) && cascade.children.length) {
      genCascadeNodes(cascade.children, keyMap, type);
    }
  });
};

const genCascadeKeyMap = (cascadeNodes = []) => {
  let keyMap;
  if (Array.isArray(cascadeNodes)) {
    keyMap = {};
    genCascadeNodes(cascadeNodes, keyMap);
  }
  return keyMap || {};
};

const genCascadeNodeRouteTitles = (nodes, routeTitleMap, routeTitle = '') => {
  nodes.forEach((cascade) => {
    routeTitleMap[routeTitle.concat(cascade.title)] = cascade;
    if (Array.isArray(cascade.children) && cascade.children.length) {
      genCascadeNodeRouteTitles(
        cascade.children,
        routeTitleMap,
        routeTitle.concat(cascade.title, '/'),
      );
    }
  });
};

const genCascadeRouteTitleMap = (prop) => {
  let routeTitleMap;
  if (prop?.type === 'cascade' && Array.isArray(prop.cascade?.nodes)) {
    routeTitleMap = {};
    genCascadeNodeRouteTitles(prop.cascade.nodes, routeTitleMap);
  }
  return routeTitleMap || {};
};

const genCascadeRouteKeyMap = (prop) => {
  const keyMap = {};
  if (prop?.type === 'cascade' && Array.isArray(prop.cascade?.nodes)) {
    genCascadeNodes(prop.cascade.nodes, keyMap, 'routeKey');
  }
  return keyMap;
};

const addCascadeNode = async (originalProp, cascadeAdd, nodesMap, routeTitlesMap) => {
  const route = cascadeAdd.split('/');
  let parentNode = null,
    addKey = '';
  const cascade = originalProp.cascade
    ? JSON.parse(JSON.stringify(originalProp.cascade))
    : {
        nodes: [],
        nodesMap: {},
        titles: [],
      };
  for (let i = 0; i < route.length; i++) {
    if (parentNode) {
      if (Array.isArray(parentNode.children) && parentNode.children.length) {
        let parent = parentNode.children.find((x) => x.title === route[i]);
        if (!parent) break;
        parentNode = parent;
        route.splice(0, 1);
        i--;
      } else {
        break;
      }
    } else {
      let parent = cascade.nodes.find((x) => x.title === route[i]);
      if (!parent) break;
      parentNode = parent;
      route.splice(0, 1);
      i--;
    }
  }
  const findNodePath = (node, routes, nMap) => {
    if (node.parentKey) {
      const parent = nMap[node.parentKey];
      if (parent) {
        routes.push(parent.title);
        findNodePath(parent, routes, nMap);
      }
    }
  };
  if (route.length) {
    if (!parentNode) {
      if (!route[0]) return [cascade, addKey];
      const key = '0-'.concat(await sha256(route[0]));
      if (nodesMap[key]) return [cascade, addKey];
      parentNode = {
        key: key,
        routeKey: '1-'.concat(await sha256(route[0].concat(CASCADE_CONNECTOR))),
        title: route[0],
        children: [],
      };
      cascade.nodes.push(parentNode);
      nodesMap[key] = parentNode;
      routeTitlesMap[route[0]] = parentNode;
      if (!cascade.titles.length) cascade.titles.push('第1级');
      route.splice(0, 1);
      addKey = key;
    }
    if (route.length) {
      for (let index = 0; index < route.length; index++) {
        const title = route[index];

        if (!title) break;
        if (!parentNode.children) parentNode.children = [];
        const routes = [parentNode.title];
        findNodePath(parentNode, routes, nodesMap);
        const levelPre = (routes.length + 1).toString().concat('-');
        const ck = '0-'.concat(
          await sha256(routes.reverse().join(CASCADE_CONNECTOR).concat(CASCADE_CONNECTOR, title)),
        );
        if (nodesMap[ck]) break;
        const newNode = {
          key: ck,
          routeKey: levelPre.concat(
            await sha256(
              routes
                .reverse()
                .join(CASCADE_CONNECTOR)
                .concat(CASCADE_CONNECTOR, title, CASCADE_CONNECTOR),
            ),
          ),
          title: title,
          parentKey: parentNode.key,
          children: [],
        };
        parentNode.children.push(newNode);
        nodesMap[ck] = newNode;
        routeTitlesMap[routes.reverse().join('/').concat('/', title)] = newNode;
        if (cascade.titles.length < routes.length + 1)
          cascade.titles.push(`第${routes.length + 1}级`);
        parentNode = newNode;
        addKey = ck;
      }
    }
  }
  return [cascade, addKey, nodesMap, routeTitlesMap];
};

const genRouteTitle = (key, nodesMap) => {
  const routes = [];
  function genParentKey(ck) {
    const parent = nodesMap[ck];
    if (parent.parentKey) {
      genParentKey(parent.parentKey);
    }
    routes.push(parent.title);
  }
  genParentKey(key);
  return routes;
};

const displayCascadeValue = (props) => {
  const {
    value,
    rArr = true,
    forceRoutes = true,
    cascadeNodes = [],
    cascadeMap = null,
    multiple = false,
    hideRoutes = false,
  } = props;

  if (!value || !value.length) return [];

  const display = [];
  let isInvalid = false;
  if (Array.isArray(value) && cascadeNodes) {
    // remove routeKey
    const valueKeys = value.filter((i) => i[0] === '0');

    const nodesMap = cascadeMap ? cascadeMap : genCascadeKeyMap(cascadeNodes);
    if (multiple) {
      valueKeys.forEach((v) => {
        if (nodesMap[v]) {
          if (hideRoutes && !forceRoutes) {
            display.push(nodesMap[v].title);
          } else {
            const routes = genRouteTitle(v, nodesMap);
            display.push(rArr ? routes : routes.join(' / '));
          }
        } else {
          isInvalid = true;
        }
      });
    } else {
      const first = value.find((v) => nodesMap[v]);
      if (first) {
        if (hideRoutes && !forceRoutes) {
          display.push(nodesMap[first].title);
        } else {
          const routes = genRouteTitle(first, nodesMap);
          display.push(rArr ? routes : routes.join(' / '));
        }
      } else {
        isInvalid = true;
      }
    }
  }

  if (isInvalid) {
    return ['无效配置，请重新选择'];
  }

  return display;
};

module.exports = {
  generateAddOpId,
  conditionMatchPropsData,
  textSort,
  getTempPropEnumOption,
  propIsNull,
  getSubString32,
  isBetween,
  conditionMatchForApp,
  filterNumber,
  copyBrowserUrl,
  calcFormula,
  genCascadeKeyMap,
  genCascadeRouteKeyMap,
  addCascadeNode,
  genCascadeRouteTitleMap,
  displayCascadeValue,
  ...newApi,
};
